<template lang="pug">
#modal-editar-ordem-de-corte
    el-dialog(
        width='600px',
        title='Editar',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(label-position='top')
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Numero da ordem de corte

                        el-input(v-model='numeroOrdemCorte', placeholder='Numero da ordem de corte', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Fazenda

                        el-input(v-model='codigoFazenda', placeholder='Fazenda')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Código do Talhão

                        el-input(v-model='codigoTalhao', maxlength='200', placeholder='Código do Talhão')
                
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Área (ha)

                        el-input(v-model='area', maxlength='200', placeholder='Área (ha)', type='number')
            
            el-row(:gutter="20")
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Estimativa de TCH (t)

                        el-input(v-model='estimativaTch', maxlength='200', placeholder='Estimativa de TCH (t)', type='number')
                el-col(:span="12")
                    el-form-item
                        template(slot='label')
                            span Data

                        el-date-picker(
                            v-model='dataCorte',
                            placement='bottom-start',
                            type='date',
                            placeholder='Data',
                            format='dd/MM/yyyy'
                        )

        footer.espaco(slot='footer')
            BaseButton(type='default', @click='fechar') Cancelar

            BaseButton(
                type='primary',
                @click='salvar'
                :disabled='!checkCamposValidos()',
            ) Salvar

</template>

<script>
import ModalAtalhoTerritorio from '@/components/ModalAtalhoTerritorio';
import RastreabilidadeOrdemDeCorteService from '@/services/RastreabilidadeOrdemDeCorteService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEditarOrdemDeCorte',
    emits: ['atualizarDadosDeCorte'],
    components: {
        ModalAtalhoTerritorio,
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dadosOrdemDeCorte: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            id: '',
            numeroOrdemCorte: '',
            codigoFazenda: '',
            codigoTalhao: '',
            area: '',
            estimativaTch: '',
            dataCorte: ''
        };
    },

    watch: {
        mostrar() {
            if (this.dadosOrdemDeCorte) {
                this.id = this.dadosOrdemDeCorte.id;
                this.numeroOrdemCorte = this.dadosOrdemDeCorte.numeroOrdemCorte;
                this.codigoFazenda = this.dadosOrdemDeCorte.codigoFazenda;
                this.codigoTalhao = this.dadosOrdemDeCorte.codigoTalhao;
                this.area = this.dadosOrdemDeCorte.area;
                this.estimativaTch = this.dadosOrdemDeCorte.estimativaTch;

                let dataSplit = this.dadosOrdemDeCorte.dataCorte.split('/');
                let padraoDatePicker = `${dataSplit[1]}/${dataSplit[0]}/${dataSplit[2]}`;

                this.dataCorte = new Date(padraoDatePicker);
            }
        }
    },

    methods: {
        fechar() {
            this.id = '';
            this.numeroOrdemCorte = '';
            this.codigoFazenda = '';
            this.codigoTalhao = '';
            this.area = '';
            this.estimativaTch = '';
            this.dataCorte = '';

            this.$emit('fechar');
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        checkCamposValidos() {
            if (
                this.numeroOrdemCorte !== '' &
                this.codigoFazenda !== '' &
                this.codigoTalhao !== '' &
                this.area !== '' &
                this.estimativaTch !== '' &
                this.dataCorte !== ''
                ) {
                    return true;
                }

            return false;
        },

        async salvar() {
            try {
                await RastreabilidadeOrdemDeCorteService.editarOrdemDeCorte({
                    id: this.dadosOrdemDeCorte.id,
                    numeroOrdemCorte: this.numeroOrdemCorte,
                    codigoFazenda: this.codigoFazenda,
                    codigoTalhao: this.codigoTalhao,
                    area: this.area,
                    estimativaTch: this.estimativaTch,
                    dataCorte: this.dataCorte.toLocaleDateString('pt-BR')
                });

                this.fechar();
                this.$emit('atualizarDadosDeCorte');

                this.$notify.success({
                    message: 'Ordem de corte editada com sucesso'
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        }
    }
};
</script>

<style lang="scss">
footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-date-editor.el-input {
    width: 100%;
}
</style>
